import { render, staticRenderFns } from "./OpenEndedComponent.vue?vue&type=template&id=21fa5dae&"
import script from "./OpenEndedComponent.vue?vue&type=script&lang=js&"
export * from "./OpenEndedComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports